import type { FaireProductEntity } from "../../entity_types/product";

export const p_gpdt9p44rr: FaireProductEntity = {
  token: "p_gpdt9p44rr",
  type: "product",
  name: "Mazel Tov Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/e1348b30eee4fb10a1a9a0c9a12db9d24465c26e36aedc65a515976265a8db8c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ae6b8edbf6bb4596bfec9927239257314121709e2992daf011f214ec5d224e16.png",
    "https://cdn.faire.com/fastly/4c902cd952891fb303dfd0a7eab3105258d2478c3338b170581a4ed381af2fec.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:38.060Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
